import { Button } from "@mui/material";
import React from "react";
import ImageIcon from '@mui/icons-material/Image';

export default function ButtonExportProject(props) {

  const handleButtonClick = (e) => {
    props.canvasRef.current.ExportToPng();
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      fullWidth
      onClick={handleButtonClick}
      startIcon={<ImageIcon fontSize="small" />}
    >
      Export to PNG
    </Button>
  );
}